export const initSSO = (btn, uri, label) => {
    if (!btn) return;

    btn.addEventListener('click', (e) => {
        e.preventDefault();

        btn.innerHTML = `
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ${label}
        `;
        btn.classList.add('is-loading');
        btn.style.pointerEvents = 'none';

        location.replace(uri);
    });
};
